<template>
  <div
    v-if="errors?.length"
    class="validation-summary"
    aria-live="assertive"
  >
    <hr v-if="showHorizontalRule">

    <h5><strong>{{ title }}</strong></h5>

    <ul
      v-for="(error, index) in errors"
      :key="index"
    >
      <li>{{ error }}</li>
    </ul>

    <hr v-if="showHorizontalRule">
  </div>
</template>

<script lang="ts" setup>defineProps<{
    errors?: string[],
    title: string,
    showHorizontalRule: boolean
  }>();
</script>
